import useSWRImmutable from 'swr/immutable'
import { DACKIE } from '@pancakeswap/tokens'

export const useDackiePrice = (chainId: string | number) => {
  return useSWRImmutable(
    ['dackie-usd-price'],
    async () => {
      const dackie = await (
        await fetch(`https://token_price.dackieswap.workers.dev/v3/${chainId}/token-price/${DACKIE[chainId].address}`)
      ).json()
      return dackie.derivedUSD as string
    },
    {
      refreshInterval: 15_000 * 10,
    },
  )
}
